export const columns = [
  {
    title: "材料名称",
    width: 200,
    dataIndex: "name",
    key: "name",
  },
  {
    title: "品牌",
    width: 200,
    dataIndex: "materialCategoryBrandName",
    key: "materialCategoryBrandName",
  },
  {
    title: "规格型号",
    width: 200,
    dataIndex: "model",
    key: "model",
  },
  {
    title: "预算成本价",
    width: 100,
    dataIndex: "costPrice",
    key: "costPrice",
  },
  {
    title: "市场销售价",
    width: 100,
    dataIndex: "salesPrice",
    key: "salesPrice",
  },
];
